export const fetchIndex = async (projectId) => {
  const querySnapshot = await  myFirestore
      .collection('projects')
      .doc(projectId)
      .collection('reports')
      .orderBy('index', 'desc')
      .limit(1)
      .get();

  let result = null

  querySnapshot.forEach((data) => {
    result = Number(data.data().index) + 1;
  });

  return result || 1;
}


export const fetchReport = async (projectId, reportId) => {
  return myFirestore
    .collection('projects')
    .doc(projectId)
    .collection('reports')
    .doc(reportId)
    .get()
};

export const copyReport = async (id, projectId, index) => {
  const response = await fetchReport(projectId, id)
  const report = {...response.data()};

  const ref = await myFirestore
    .collection('projects')
    .doc(projectId)
    .collection('reports')
    .add({
      ...report,
      from: null,
      index
    })

  return {
    id: ref.id,
    index
  };
}


export const copyChild = async (reportData, projectId) => {
  const modifyReportData = {...reportData};
  let index =  await fetchIndex(projectId)
  const parentIndex = index
  if(reportData.reportPROF) {
    index ++;

    const responseId = await copyReport(reportData.reportPROF, projectId, index)
    modifyReportData.reportPROF = responseId.id;
    modifyReportData.PROF = {
      ...modifyReportData.PROF,
      index: index
    };
  }

  if(reportData.reportTECH) {
    index ++;

    let index =  await fetchIndex(projectId)
    const responseId = await copyReport(reportData.reportTECH, projectId, index)
    modifyReportData.reportTECH = responseId.id;
    modifyReportData.TECH = {
      ...modifyReportData.TECH,
      index: index
    };
  }

  modifyReportData.index = parentIndex
  modifyReportData.is_temp = true;
  return modifyReportData;
}

export const updateFrom = async (projectId, reportData, fromId) => {
  if(reportData.reportPROF) {
    await myFirestore
      .collection('projects')
      .doc(projectId)
      .collection('reports').doc(reportData.reportPROF)
      .update({
        from: fromId
      })
  }

  if(reportData.reportTECH) {
    await myFirestore
      .collection('projects')
      .doc(projectId)
      .collection('reports')
      .doc(reportData.reportTECH)
      .update({
        from: fromId
      })
  }
}



// WEBPACK FOOTER //
// ./src/firestore/reports.js